export const version = '1.0.0'
export const supportLink = 'mailto:support@beaware.online'
export const companyName = 'SecurePath AI'
export const termsOfService = 'https://securepath.beaware.online/terms.html'
export const storeURL = 'https://securepath.beaware.online'
export const flavor = 'securepath'
export const googleClientId ='318948493392-h2a6occ4bh1v0pg4l9l9viq8d23mnfas.apps.googleusercontent.com'
